const Spark = {
  install(Vue) {
    const Spark = (name) => {
      return _.get(window.Spark, name);
    };

    Vue.prototype.$Spark = Spark;
    Vue.Spark = Spark;
  },
};

export default Spark;
